export default __webpack_public_path__ + "static/media/ugi_logo_inner.5583c2a6.svg";